import React, { Component } from 'react';
import { compose } from 'redux';
import { Controller } from 'react-hook-form';
import moment from 'moment';
import DateTime from 'react-datetime';
import { searchCustomerRegistrationsByPhone } from 'services/customer-registration.service';
import { reduce } from 'lodash';

import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import withForm from 'hoc/withForm';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button';
import CustomTextField from 'components/CustomTextField/CustomTextField';
import AsyncAutocomplete from 'components/AsyncAutocomplete/AsyncAutocomplete';
import { shortDateFormat } from 'resolvers/date-format.resolver';

import styles from 'assets/jss/material-dashboard-pro-react/components/scheduledCallFormStyle';

class ScheduledCallForm extends Component {

	state = {
		customCallPurposeError: '',
	}

	availableDurations = [15, 30, 45];
	availableReminders = [5, 10, 15];

	componentDidMount() {
		const { formMethods } = this.props;
		const { reset } = formMethods;
		reset(this.props.defaults);
	}

	onSubmit = (data) => {
		const {
			isEdit,
			formMethods,
			onSubmit,
		} = this.props;

		const { formState, reset } = formMethods;

		const { dirtyFields } = formState;

		const dirtyData = {};

		if (isEdit) {
			reduce(dirtyFields, (result, value, key) => {
				result[key] = data[key];
				return result;
			}, dirtyData);
		}

		const resetCallBack = () => {
			reset(data);
		};
		onSubmit(isEdit ? dirtyData : data, resetCallBack);
	}

	render() {
		const { customCallPurposeError } = this.state;

		const {
			classes,
			formMethods,
			customCallPurposeOptions = [],
			callCenterOptions = [],
			onError,
			isEdit,
			defaults,
			isReminderSent = false,
			isInPast = false,
		} = this.props;

		const { control, trigger, handleSubmit, formState } = formMethods;

		const { errors, isDirty, isSubmitting } = formState;

		const phoneFilter = createFilterOptions({
			stringify: (option) => `+${option.phoneNumber}`,
		});

		const yesterday = moment().subtract(1, 'day');
		const now = moment().minute(0).second(0);

		return (

			<form
				className={classes.formContainer}
				onSubmit={handleSubmit(this.onSubmit, onError)}
				noValidate>

				<GridContainer justify='center' className={classes.detailsContainer}>
					{
						isReminderSent && !isInPast && <GridItem xs={12} sm={12} md={12}>
							<div className={classes.title}>
								{"You cannot edit an Appointment as pre-call Reminder has been sent already."}
							</div>
						</GridItem>
					}
					{
						isInPast && <GridItem xs={12} sm={12} md={12}>
							<div className={classes.title}>
								{"You cannot edit Appointment in the past."}
							</div>
						</GridItem>
					}
					<GridItem xs={12} sm={12} md={6}>
						<Controller
							name="callPurpose"
							control={control}
							defaultValue={defaults.callPurpose}
							rules={{
								required: 'Field should not be empty',
							}}
							render={({ onChange, value }) => (
								<Autocomplete
									options={customCallPurposeOptions}
									autoComplete
									freeSolo
									value={value}
									includeInputInList
									disabled={isEdit}
									renderInput={(params) => <CustomTextField {...params}
										label="Call purpose *"
										margin="normal"
										error={!!errors.callPurpose || !!customCallPurposeError}
										helperText={errors.callPurpose ? errors.callPurpose.message : customCallPurposeError}
										onChange={(event) => {
											const newValue = event.target.value?.trimStart();
											if (newValue.length > 39) {
												this.setState({ customCallPurposeError: 'Call purpose max length is 39 characters' });
											} else {
												this.setState({ customCallPurposeError: '' });
											}
										}}
									/>}
									renderOption={(option) => option.customNotification}
									onChange={(e, value) => {
										onChange(value);
										trigger('callPurpose');
									}}
									onBlur={(event) => {
										const value = event.target.value.trim();
										if (value !== '') {
											const newItem = {
												customNotification: value,
											};
											onChange(newItem);
										}
										else {
											onChange(null);
										}
										trigger('callPurpose');
									}}
									getOptionLabel={(option) => {
										return option.customNotification;
									}}
								/>
							)}
						/>
					</GridItem>
					<GridItem xs={12} sm={12} md={6}>
						<Controller
							name="dateTime"
							control={control}
							defaultValue={defaults.dateTime}
							rules={{
								required: 'Field should not be empty',
							}}
							render={({ onChange, value }) => (
								<FormControl fullWidth>
									<div className={classes.dateTimeWrapper}>
										<DateTime
											renderInput={(props) =>
												<CustomTextField {...props}
													error={!!errors.dateTime}
													helperText={errors.dateTime ? errors.dateTime.message : ""}
													label="Appointment date/time *"
													margin="normal"
													inputProps={{ readOnly: true }}
												/>}
											value={value}
											isValidDate={(current) => {
												return current.isAfter(yesterday);
											}}
											timeConstraints={{
												minutes: {
													step: 15
												},
											}}
											inputProps={{
												fullWidth: true,
												disabled: isReminderSent || isInPast,
											}}
											timeFormat={true}
											dateFormat={shortDateFormat}
											onChange={(value) => {
												if (value.isAfter(yesterday)) {
													onChange(value._d);
												} else {
													onChange(now.hour(value.hour()).minute(value.minute())._d);
												}
												trigger('dateTime');
											}}
											onClose={() => {
												trigger('dateTime');
											}}
										/>
									</div>
								</FormControl>
							)}
						/>
					</GridItem>
					<GridItem xs={12} sm={12} md={6}>
						<Controller
							name="callDuration"
							control={control}
							defaultValue={defaults.callDuration}
							rules={{
								required: 'Field should not be empty',
							}}
							render={({ onChange, value }) => (
								<Autocomplete
									options={this.availableDurations}
									autoComplete
									includeInputInList
									disabled={isEdit}
									value={value}
									renderInput={(params) =>
										<CustomTextField {...params}
											error={!!errors.callDuration}
											helperText={errors.callDuration ? errors.callDuration.message : ""}
											label="Call duration *"
											margin="normal" />
									}
									getOptionLabel={(option) => {
										return `${option} min`;
									}}
									onChange={(e, val) => {
										onChange(val);
										trigger('callDuration');
									}}
									onBlur={() => {
										trigger('callDuration');
									}}
								/>
							)}
						/>
					</GridItem>
					<GridItem xs={12} sm={12} md={6}>
						<Controller
							name="reminder"
							control={control}
							defaultValue={defaults.reminder}
							rules={{
								required: 'Field should not be empty',
							}}
							render={({ onChange, value }) => (
								<Autocomplete
									options={this.availableReminders}
									autoComplete
									includeInputInList
									disabled={isEdit}
									value={value}
									renderInput={(params) =>
										<CustomTextField {...params}
											error={!!errors.reminder}
											helperText={errors.reminder ? errors.reminder.message : ""}
											label="Pre-call reminder *"
											margin="normal" />
									}
									getOptionLabel={(option) => {
										return `${option} min`;
									}}
									onChange={(e, val) => {
										onChange(val);
										trigger('reminder');
									}}
									onBlur={() => {
										trigger('reminder');
									}}
								/>
							)}
						/>
					</GridItem>
					<GridItem xs={12} sm={12} md={6}>
						<Controller
							name="callTo"
							control={control}
							defaultValue={defaults.callTo}
							rules={{
								required: 'Field should not be empty',
							}}
							render={({ onChange, value }) => (
								<AsyncAutocomplete
									label="Call to *"
									optionLabel="phoneNumber"
									isPhoneSearch={true}
									value={value}
									searchHandler={searchCustomerRegistrationsByPhone}
									searchOptions={{
										sortBy: [{ id: "phoneNumber", desc: false }],
										include: ['phoneNumber'],
									}}
									filterOptions={(options, params) => {
										return phoneFilter(options, params);
									}}
									formStateError={errors.callTo}
									disabled={isEdit}
									onChange={(val) => {
										onChange(val);
										trigger('callTo');
									}}
									onBlur={() => {
										trigger('callTo');
									}}
								/>
							)}
						/>
					</GridItem>
					<GridItem xs={12} sm={12} md={6}>
						<Controller
							name="callCenter"
							control={control}
							defaultValue={defaults.callCenter}
							rules={{
								required: 'Field should not be empty',
							}}
							render={({ onChange, value }) => (
								<Autocomplete
									options={callCenterOptions.filter((option) => option && option.name)}
									autoComplete
									includeInputInList
									value={value}
									disabled={isReminderSent || isInPast}
									getOptionLabel={(option) => {
										return option.name;
									}}
									renderInput={(params) =>
										<CustomTextField {...params}
											error={!!errors.callCenter}
											helperText={errors.callCenter ? errors.callCenter.message : ""}
											label="Contact Center *"
											margin="normal" />
									}
									onChange={(e, val) => {
										onChange(val);
										trigger('callCenter');
									}}
									onBlur={() => {
										trigger('callCenter');
									}}
								/>
							)}
						/>
					</GridItem>
					<GridItem xs={12} sm={12} md={6}>
					</GridItem>
					<GridItem xs={12} sm={12} md={6} className={classes.actionContainer}>
						<Button
							color='danger'
							type='submit'
							disabled={
								!!Object.keys(errors).length
								|| isSubmitting
								|| !isDirty
							}
						>Save</Button>
					</GridItem>
				</GridContainer>
			</form>
		);
	}
}

export default compose(
	withStyles(styles),
	withForm,
)(ScheduledCallForm);
